import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IDeadwoodRipGameData, IDeadwoodRipInitData} from "./data/IDeadwoodRipData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {DeadwoodRipParsedInitData} from "./data/DeadwoodRipParsedInitData";
import {DeadwoodRipParsedGameData} from "./data/DeadwoodRipParsedGameData";
import {DeadwoodRipDataParser} from "./data/DeadwoodRipDataParser";
import {DeadwoodRip} from "../DeadwoodRip";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class DeadwoodRipModel extends GameModel<IDeadwoodRipInitData, IDeadwoodRipGameData> {

    public parsedInitData:DeadwoodRipParsedInitData;
    public parsedGameData:DeadwoodRipParsedGameData;
    public reels:string[][];
    public isRestore:boolean = false;
    public restoredFeatureBetName:string;

    private _parser:DeadwoodRipDataParser;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data:boolean) => {
            if(data) {
                api.events.once("featureName", (name:string) => {
                    this.restoredFeatureBetName = name;
                });
            }
        });
        SlotGame.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:any) => {
            if(data === true) {
                DeadwoodRip.isActionSpinsActive = true;
                DeadwoodRip.individualWin.stop();
            } else {
                DeadwoodRip.isActionSpinsActive = false;
            }
        });
        this._parser = new DeadwoodRipDataParser();
    }

    protected onInit(data:IDeadwoodRipInitData):void {
        this.parsedInitData = new DeadwoodRipParsedInitData(data, this._parser);
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        super.onInit(data);
    }

    protected onGame(data:IDeadwoodRipGameData):void {
        if(DeadwoodRip.isActionSpinsActive) {
            return;
        }
        this.parsedGameData = new DeadwoodRipParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }
}